import type { ReactNode } from "react";
import type { SelectOption, SelectValue } from "./select";

export const labelText = (label: ReactNode) =>
  typeof label === "string" || typeof label === "number" ? String(label) : "";

/** Text shown for / matched against an option: `searchText`, else the label when it is plain text. */
export const optionText = <V extends SelectValue>(option: SelectOption<V>) =>
  option.searchText ?? labelText(option.label);

/** `showSearch` filter: case-insensitive substring match on the option's text (see `SelectOption.searchText`). */
export const matchesSearch = <V extends SelectValue>(option: SelectOption<V>, query: string) =>
  optionText(option).toLowerCase().includes(query.trim().toLowerCase());
